import request, { FormDataHeader } from '@/utils/request'
import {
  PageQuery,
  UserDeviceItem,
  BrandItem,
  ActivityTagItem,
  GetActivityListQuery,
  ActivityListItem,
  RecordListPageResult,
  SumbitDeviceApplyParams,
  EditDeviceApplyParams,
  SumbitDeviceApplyResult,
  CheckPayOrderStatusResult,
  GetRecordDetailQuery,
  RecordDetail,
  ChangeApplyActivityParams,
  SubmitRestMoneyPayParams,
  SubmitRestMoneyPayResult,
} from '@/types/device-replace-v3'

// 获取用户是否已浏览过指引
export function getUserGuideStatus(): Promise<{ count: string }> {
  return request.get(`/api-crm/farm/exchange/guide`)
}
// 更新用户指引浏览状态
export function updateUserGuideStatus(): Promise<void> {
  return request.get(`/api-crm/farm/exchange/add_guide`)
}

export function getUserDeviceList(): Promise<UserDeviceItem[]> {
  return request.get(`/api-crm/farm/exchange/index`)
}
export function getBrandList(): Promise<BrandItem> {
  return request.get('/api-crm/farm/exchange/select_brand')
}
export function getActivityTagList(): Promise<ActivityTagItem[]> {
  return request.get('/api-crm/farm/exchange/tag')
}

export function getActivityList(params: GetActivityListQuery): Promise<ActivityListItem[]> {
  return request.get('/api-crm/farm/exchange/activity', { params })
}
export function checkProductSn(params: {
  product_sn: string
  order_guid: string
}): Promise<{ message: string }> {
  return request.get('/api-crm/farm/exchange/check_apply', { params })
}
// 提交申请单
export function sumbitDeviceApply(params: SumbitDeviceApplyParams): Promise<{
  res: SumbitDeviceApplyResult
}> {
  return request.post('/api-crm/farm/exchange/save', params)
}
// 修改申请单
export function editDeviceApply(params: EditDeviceApplyParams): Promise<void> {
  return request.post('/api-crm/farm/exchange/chang_model', params)
}
// 支付尾款获取付款单号
export function submitPayRestMoney(
  params: SubmitRestMoneyPayParams
): Promise<SubmitRestMoneyPayResult> {
  return request.post('/api-crm/farm/exchange/pay', params)
}
// 查询尾款支付结果
export function checkPayOrderStatus(params: {
  order_no: string
}): Promise<CheckPayOrderStatusResult> {
  return request.get('/api-crm/farm/exchange/pay_status', { params })
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       guid: 'string',
  //       pay_no: 'string',
  //       pay_sn: 'string',
  //       status: 2,
  //     })
  //   }, 2000)
  // })
}
export function getApplyRecordList(params: PageQuery): Promise<RecordListPageResult> {
  return request.get('/api-crm/farm/exchange/list', { params })
}
export function getApplyRecordDetail(params: GetRecordDetailQuery): Promise<RecordDetail> {
  return request.get('/api-crm/farm/exchange/detail', { params })
}
export function changeApplyActivity(params: ChangeApplyActivityParams): Promise<void> {
  return request.post('/api-crm/farm/exchange/change', params)
}
export function cancelOrder(params: { guid: string; remark?: string }): Promise<void> {
  return request.post('/api-crm/farm/exchange/cancel', params, {
    headers: FormDataHeader,
  })
}
// 确认收货
export function confirmReceiveProduct(params: { guid: string }): Promise<void> {
  return request.get('/api-crm/farm/exchange/receipt', { params })
}
